// @flow
import React, { Component } from 'react'
import type { Match } from '../../../types'
import { ADMIN_NAVIGATION_PATHNAMES } from '../../../data/auth'
import SearchView from './SearchView'
import type { TabItem } from '../../../components/Tabs'

type Props = {|
  match: Match,
  redirectAction: (address: string) => void
|}

class SearchController extends Component<Props> {
  componentDidMount () {
    const { redirectAction } = this.props
    redirectAction(ADMIN_NAVIGATION_PATHNAMES.OrderSearch)
  }

  componentDidUpdate () {
    const { redirectAction } = this.props
    if (window.location.pathname === '/search') {
      redirectAction(ADMIN_NAVIGATION_PATHNAMES.OrderSearch)
    }
  }

  get tabs (): TabItem[] {
    return [
      { title: 'Order', path: ADMIN_NAVIGATION_PATHNAMES.OrderSearch },
      { title: 'Employee', path: ADMIN_NAVIGATION_PATHNAMES.EmployeeSearch }
    ]
  }

  render () {
    return (
      <SearchView
        match={this.props.match}
        tabs={this.tabs} />
    )
  }
}

export default SearchController
